import { jsx as d } from "react/jsx-runtime";
import "../../../node_modules/@mercadopago/sdk-react/esm/mercadoPago/initMercadoPago/index.mjs";
import { useState as P, useEffect as b, useMemo as g } from "react";
import "../../../node_modules/@mercadopago/sdk-react/esm/bricks/util/initial/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/bricks/util/renderBrick/index.mjs";
import E, { useCardPaymentBrick as x } from "../../../node_modules/@mercadopago/sdk-react/esm/bricks/cardPayment/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/coreMethods/getIdentificationTypes/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/coreMethods/getPaymentMethods/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/coreMethods/getInstallments/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/coreMethods/getIssuers/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/secureFields/createCardToken/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/secureFields/updateCardToken/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/secureFields/util/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/authenticator/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/coreMethods/getAccountPaymentMethods/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/coreMethods/getCardId/index.mjs";
import "../../../node_modules/@mercadopago/sdk-react/esm/coreMethods/updatePseudotoken/index.mjs";
import { ContactSlugEnum as S, centsToUnits as u } from "@systemeio/ui";
import { useMercadoPagoStore as M, useOfferStore as v } from "../../../store/index.mjs";
import { useDesignContext as T } from "../../../providers/use-design-provider.mjs";
import { getColors as B } from "../../../themes/utils/color-utils.mjs";
function W() {
  var n;
  const { state: s } = T(), { initialized: o } = M(), [e, l] = P(!1), { primaryColor: i, secondaryColor: a, textColorPrimary: p, textColorTertiary: c, tertiaryColor: f } = B(s), { finalAmount: r, contactFields: t } = v(), C = (n = t == null ? void 0 : t[S.Email]) == null ? void 0 : n.value, { update: y } = x();
  return b(() => {
    r && o && e && y({ amount: u(r) });
  }, [r, o, e]), g(() => !r || !o ? null : /* @__PURE__ */ d(
    E,
    {
      initialization: { amount: u(r), payer: { email: C } },
      customization: {
        visual: {
          hidePaymentButton: !0,
          style: {
            customVariables: {
              textPrimaryColor: c,
              inputBackgroundColor: f,
              formBackgroundColor: a,
              baseColor: i,
              baseColorFirstVariant: i,
              baseColorSecondVariant: a,
              outlinePrimaryColor: "var(--THEME-border-tertiary)",
              outlineSecondaryColor: "var(--THEME-border-tertiary)",
              buttonTextColor: p
            }
          }
        }
      },
      onSubmit: async (m) => {
      },
      onError: (m) => console.log("MP error", m),
      onReady: () => {
        l(!0);
      }
    }
  ), [o]);
}
export {
  W as MercadoPagoCardDetails
};
